import { render, staticRenderFns } from "./ZoomMini.vue?vue&type=template&id=3c6ffab2"
import script from "./ZoomMini.vue?vue&type=script&lang=js"
export * from "./ZoomMini.vue?vue&type=script&lang=js"
import style0 from "./ZoomMini.vue?vue&type=style&index=0&id=3c6ffab2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports